import axios from 'config/axios';
import { saveAs } from 'file-saver';
import Auth from './Auth';

export default class Units {
    static async createClassUnit(classId, unit) {
        await Auth.checkCurrentAuthToken();
        return await axios
            .post(`/api_v2/curriculum/class/create/${classId}`, {
                unitData: { ...unit },
            })
            .then((res) => res.data);
    }

    static async createSchoolUnit(schoolId, unit) {
        await Auth.checkCurrentAuthToken();
        return await axios
            .post(`/api/v4/lessons/school/unit/create`, {
                unitData: { ...unit },
            })
            .then((res) => res.data);
    }

    static async editUnit(unitId, unit) {
        await Auth.checkCurrentAuthToken();
        return await axios
            .post(`/api/v4/lessons/units/${unitId}`, {
                ...unit,
            })
            .then((res) => res.data);
    }

    static async unitCompletionSummary(unitId) {
        await Auth.checkCurrentAuthToken();
        return await axios.get(`/api/units/getUnitCompletionSummary/${unitId}`);
    }

    static async lessonOrder(orderData) {
        await Auth.checkCurrentAuthToken();
        return await axios.post('/api_v2/curriculum/changeOrder', orderData);
    }

    static async paidLessonAccess(schoolId) {
        await Auth.checkCurrentAuthToken();
        return await axios.get(`/api_v2/options/paid-lesson-access/${schoolId}`).then((res) => res.data);
    }

    static async paidUnitAccess() {
        await Auth.checkCurrentAuthToken();
        return await axios.get(`/api_v2/options/paid-unit-access`).then((res) => res.data);
    }

    static async getTemplateUnitsForSchool() {
        await Auth.checkCurrentAuthToken();
        return await axios.get(`/api/v4/lessons/units`).then((res) => res.data.units);
    }

    static async unitCurriculumReport(unitId, fileName) {
        await Auth.checkCurrentAuthToken();
        return await axios.get(`/api/teachers/unitCurriculum/${unitId}`, { responseType: 'blob' }).then((res) => {
            saveAs(res.data, fileName);
            return true;
        });
    }
}
